import React, { useEffect, useRef } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Store } from 'redux/store';
import { useSelector } from 'react-redux';
import { Paper, Typography } from '@material-ui/core';
import { stringify } from 'qs';
import { getLocalStorage } from 'utility/browserStorageUtil';
import { accessHistoryApi } from 'api/authApi';
import moment from 'moment';
import useStyles from '../styles';

function FinishBookingPage() {
  const location = useLocation();
  const urlSearchParam = new URLSearchParams(location.search);
  const companyCode = urlSearchParam.get('companyCode') || getLocalStorage('companyCode');
  const mediaCode = urlSearchParam.get('mediaCode') || getLocalStorage('mediaCode') || '';
  const timeOutRef = useRef<any>(null);
  const history = useHistory();
  const state = useSelector((reduxState: Store) => reduxState.reservationBookingOnline);
  const classes = useStyles();
  const updateSize = () => {
    if (timeOutRef.current) {
      clearTimeout(timeOutRef.current);
    }
    timeOutRef.current = setTimeout(() => {
      const height = document.getElementsByTagName('body')[0]?.clientHeight || 0;
      const obj = { event: 'iframe_height', height };
      // 親へiframeの高さを送信
      // postMessage(<送信する値>, <送信先のドメイン>)
      window.parent.postMessage(obj, 'https://www.ci-z.com');
    }, 500);
  };

  useEffect(() => {
    if (!state.detailBooking) {
      history.replace(`/contact/reservem?${stringify({ mediaCode, companyCode })}`);
    } else {
      // Save history access screen
      const paramsPost = { accessUrl: `${history?.location?.pathname + history?.location?.search}`, companyCode, staffId: '' };
      accessHistoryApi(paramsPost);
      if (companyCode === 'ci_zlabo' && state?.detailBooking?.customerClass === '1') {
        // customerClass === '1' is booking online of new customer
        window.parent.postMessage({
          event: 'page_view',
          path: location?.pathname || '',
          campaign: '',
          page: 'thanks',
          application_number: `${state?.detailBooking?.customerNumber || ''}`,
          course: `${state?.detailBooking?.contractCourseName || ''}`,
          shop: `${state?.detailBooking?.orgName || ''}`,
          birthday: `${moment(state?.detailBooking?.birthDate || '').format('YYYY年MM月DD日') !== 'Invalid date' ? moment(state?.detailBooking?.birthDate).format('YYYY年MM月DD日') : ''}`,
          mail: `${String(state?.detailBooking?.email || '')?.substring(0, String(state?.detailBooking?.email || '')?.lastIndexOf('@'))}`, // get retrieve Name from Email Address
        }, 'https://www.ci-z.com');
      }
    }
    if (companyCode === 'ci_zlabo') {
      updateSize && updateSize();
      // window.addEventListener('load', updateSize);
      window.addEventListener('resize', updateSize);
    }
    return () => {
      // window.removeEventListener('load', updateSize);
      window.removeEventListener('resize', updateSize);
      clearTimeout(timeOutRef.current);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div>
        <Typography className={classes.cssTitle}>
          仮予約が完了しました。
        </Typography>
      </div>
      <div style={{ maxWidth: '640px', width: '100%', marginTop: '1.5rem' }}>
        <Paper className={classes.inputBoxV2}>
          <Typography variant="button" align="center" className={classes.labelFillBefore}>
            予約日時
          </Typography>
          <Typography className={`${classes.inputTextLeft} ${classes.cssFontSize}`}>
            {moment(state.detailBooking?.desiredTime ?? new Date()).format('YYYY年MM月DD日HH時mm分')}
            〜
            {moment(state.detailBooking?.desiredTime ?? new Date()).add(state.detailBooking?.treatmentTime ?? 0, 'minutes').format('HH時mm分')}
          </Typography>
        </Paper>
        <Paper className={classes.inputBoxV2}>
          <Typography variant="button" align="center" className={classes.labelFillBefore}>
            店舗
          </Typography>
          <Typography className={`${classes.inputTextLeft} ${classes.cssFontSize}`}>
            {state.detailBooking?.orgName ?? ''}
          </Typography>
        </Paper>
        <Paper className={classes.inputBoxV2}>
          <Typography variant="button" align="center" className={classes.labelFillBefore}>
            希望コース
          </Typography>
          <Typography className={`${classes.inputTextLeft} ${classes.cssFontSize}`}>
            {state.detailBooking?.desiredCourse ?? ''}
          </Typography>
        </Paper>
      </div>

      <div>
        <Typography className={`${classes.typeSubText}`}>
          <br />
          この度は私どもクリニカルサロン シーズ・ラボへご予約頂き誠にありがとうございます。
          <br />
          <br />
          仮予約お申込みを受け付けました。
          <br />
          <br />
          24時間以内にお客様がご希望された店舗より、ご予約確認のお電話をさせて頂きます。
          <br />
          尚、お電話がつながらない場合ご予約はキャンセル扱いとなります。
          <br />
          何卒宜しくお願い致します。
        </Typography>
      </div>
    </>
  );
}

export default FinishBookingPage;
